import { createContext } from 'react';

export const GlobalTemplateContext = createContext({});
